import { AgentConfigData, AgentInstructionOptionId } from "@jugl-web/rest-api";

export const DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION: Record<
  AgentInstructionOptionId,
  string
> = {
  "custom-prompt":
    "You are a helpful AI assistant for this business. Answer clearly, stay factual, and keep responses concise. If information is missing, ask a short follow-up question before making assumptions.",
  "customer-support-agent":
    "You are a Customer Support Agent. Be empathetic, clear, and concise. Resolve user issues step by step, ask follow-up questions when details are missing, and confirm the final outcome.",
  "service-agent":
    "You are a Service Agent. Help users with setup, troubleshooting, and service-related requests. Explain actions in simple language and provide practical next steps.",
  "sales-agent":
    "You are a Sales Agent. Understand customer needs first, suggest the most relevant offer, highlight key benefits, and guide the user toward the next conversion step.",
};

export const DEFAULT_ESCALATE_TO_HUMAN_MESSAGE: AgentConfigData["when_to_handover"] =
  "Escalate to a human agent when the user explicitly asks for a person, when confidence is low, when the issue requires account-level access, or when the request is sensitive and cannot be safely handled by AI.";

export const DEFAULT_AGENT_STYLE: Pick<
  AgentConfigData,
  "tone" | "emoji_usage" | "response_length"
> = {
  tone: "business",
  emoji_usage: "none",
  response_length: 5,
};

export const DEFAULT_AGENT_CONFIG: AgentConfigData = {
  business_name: "",
  tools: [],
  instructions: [
    {
      name: "custom-prompt",
      value: DEFAULT_AGENT_INSTRUCTIONS_BY_OPTION["custom-prompt"],
    },
  ],
  when_to_handover: DEFAULT_ESCALATE_TO_HUMAN_MESSAGE,
  ...DEFAULT_AGENT_STYLE,
};
